import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import {
  checkAndSetLoading,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

export const fetchMessengerFilters = createAsyncThunk(
  'messenger/fetchMessengerFilters',
  async (_, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });

    try {
      // TODO: replace with api call
      return Promise.resolve([]);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const fetchMessengerFiltersExtraReducers = builder => {
  builder
    .addCase(fetchMessengerFilters.pending, (state, action) => {
      checkAndSetLoading(state.filters, action);
    })
    .addCase(fetchMessengerFilters.fulfilled, (state, action) => {
      onMatchedRequest(state.filters, action, () => {
        state.filters.list = action.payload;
      });
    })
    .addCase(fetchMessengerFilters.rejected, (state, action) => {
      handleRequestRejection(state.filters, action);
    });
};
